<template>
  <div class="flex justify-end mb-2">
    <div class="flex gap-x-2 items-center">
      <UBadge size="xs" color="red">{{
        $t(
          'views.cottage-contact-deal.resume.total.discount',
          Math.round(item.deal.percentage),
        )
      }}</UBadge>
    </div>
  </div>

  <div class="flex justify-between">
    <div class="flex gap-x-2 items-center">
      <TText size="base" classes="m-0" :variant="'semibold'">{{
        $t('views.cottage-contact-deal.resume.total.label1')
      }}</TText>
      <TText size="sm" classes="mb-0">{{
        $t('views.cottage-contact-deal.resume.total.label2')
      }}</TText>
    </div>
    <div class="flex gap-x-2 items-center">
      <TText size="lg" classes="mb-0 text-end line-through">{{
        toEuro(item.deal.totalOld.amount)
      }}</TText>

      <TText size="lg" classes="m-0 " variant="semibold" color="red800">{{
        toEuro(item.deal.total.amount)
      }}</TText>
    </div>
  </div>

  <div class="flex justify-between">
    <div class="">
      <TText size="sm" classes="mb-0">{{
        $t('views.cottage-contact-deal.resume.total.payment')
      }}</TText>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CottageContactDealPage } from '~/modules/views/cottage-contact-deal/entities/CottageContactDealPage'

type itemType = {
  deal: Pick<
    CottageContactDealPage['deal'],
    'total' | 'totalOld' | 'percentage'
  >
}

interface propsInterface {
  item: itemType
}

defineProps<propsInterface>()
</script>
